import {inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {
    ActivitySearchEngineDialogComponent
} from '@modules/activities/core/activities-search-engine';
import {CommunicationCenterService} from "@modules/communication-center";
import {ActivitySearchEngineConfig} from "@modules/activities/core/activities-search-engine/activity-search-engine.config";

@Injectable({
    providedIn: 'root'
})
export class ActivitiesSearchEngineService {

    public dialog = inject(MatDialog);
    private communicationCenter = inject(CommunicationCenterService);

    public openSearchActivityEngine(config?: ActivitySearchEngineConfig) {
        if (config) {
            this.setConfig(config);
        }
        const searchEngineDialog = this.dialog.open(ActivitySearchEngineDialogComponent, {
            panelClass: 'activity-search-engine__dialog',
        });
        return searchEngineDialog.afterClosed();
    }

    public setConfig(config: ActivitySearchEngineConfig): void {
        this.communicationCenter
            .getRoom('activity-search-engine')
            .next('config', config);
    }
}
